export const iconFontAwesomeAutomotiveGauge = (
	<i className="fa-solid fa-gauge"></i>
);
